import { getRequest } from './http.interceptor';

export const findADealer = async ({
  address,
  distMiles,
  maxItemPerPage,
  page
}) => {
  return await getRequest(
    `/geojson/energy/dealers?address=${address}&brand=energy&distMiles=${distMiles}&maxItemPerPage=${maxItemPerPage}&page=${page}`
  );
};

export async function getAzureMapLocation(searchparam) {
  const  azureMapKey  = process.env.NEXT_PUBLIC_AZURE_MAP_KEY;
  try {
    const res = await fetch(
      ` https://atlas.microsoft.com/search/address/structured/json?api-version=1.0&subscription-key=${azureMapKey}&postalCode=${encodeURIComponent(searchparam)}&countryCode=US`,
      {
        method: 'GET'
      }
    );
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}